import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { RadioGroup, FormControlLabel, Radio } from "@material-ui/core";
import { CreateDisbursementFormFields } from "../Hooks/useCreateDisbursementForm";
import useStyles from "./styles";

const BankAccountRadioGroup = () => {
  const { control } = useFormContext<CreateDisbursementFormFields>();
  const classes = useStyles();
  return (
    <Controller
      as={
        <RadioGroup className={classes.radioGroup}>
          <FormControlLabel
            className={classes.radioGroupOption}
            control={<Radio color="primary" />}
            label="Existing"
            labelPlacement="end"
            value={"EXISTING"}
          />
          <FormControlLabel
            className={classes.radioGroupOption}
            control={<Radio color="primary" />}
            label="New"
            labelPlacement="end"
            value={"NEW"}
          />
        </RadioGroup>
      }
      control={control}
      name="bankAccountOptionRadioGroup"
    />
  );
};

export default BankAccountRadioGroup;
